import React from 'react';
import { Link } from 'react-router-dom';

export default function StadiumCrumbs({ items }) {
  const crumbs = (items || []).filter((item) => item && item.label);

  if (!crumbs.length) return null;

  return (
    <nav className="st-crumbs" aria-label="breadcrumb">
      {crumbs.map((item, index) => {
        const isCurrent = index === crumbs.length - 1 || !item.to;
        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 ? <span className="st-crumbs-sep">/</span> : null}
            {isCurrent ? (
              <span className="st-crumb is-current">{item.label}</span>
            ) : (
              <Link to={item.to} className="st-crumb">
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
